/* eslint-disable */
import axios from 'axios';
import { getStorage } from './localstorage';

axios.interceptors.request.use(
  (config) => {
    const authToken = getStorage('token');
    // if (authToken) {
    //   config.headers['Authorization'] = `${authToken}`;
    // }
    return config;
  },
  (error) => Promise.reject(error),
);

export default axios;
